import { Checkbox, FormControlLabel } from "@mui/material";

const CheckboxComponent = ({ label, checkboxProps, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox sx={{ py: { xs: 0, sm: 0 }, px: 0.5, ...checkboxProps }} />
      }
      label={label}
      sx={{
        "& .MuiFormControlLabel-label": { fontSize: { xs: 12, sm: 16 } },
        alignItems: { xs: "flex-start", sm: "center" },
        width: "fit-content",
      }}
      {...props}
    />
  );
};

export default CheckboxComponent;
